var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatluong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.76819 10.3927C3.38013 9.31867 3.1861 8.78167 3.26884 8.43756C3.35933 8.06118 3.627 7.76775 3.96913 7.66987C4.28193 7.58037 4.76853 7.79664 5.74173 8.22918C6.60253 8.61177 7.03293 8.80306 7.43732 8.79242C7.88257 8.7807 8.31088 8.60215 8.6516 8.28622C8.96105 7.99928 9.16861 7.54204 9.58373 6.62755L10.4986 4.61216C11.2628 2.92866 11.6449 2.08691 12.25 2.08691C12.8551 2.08691 13.2372 2.92866 14.0014 4.61216L14.9163 6.62755C15.3314 7.54204 15.539 7.99928 15.8484 8.28622C16.1891 8.60215 16.6174 8.7807 17.0627 8.79242C17.4671 8.80306 17.8975 8.61177 18.7583 8.22918C19.7315 7.79664 20.2181 7.58037 20.5309 7.66987C20.873 7.76775 21.1407 8.06118 21.2312 8.43756C21.3139 8.78167 21.1199 9.31867 20.7318 10.3926L19.0638 15.0091C18.3502 16.9839 17.9935 17.9713 17.2468 18.5291C16.5002 19.0869 15.5354 19.0869 13.6058 19.0869H10.8942C8.96459 19.0869 7.99977 19.0869 7.25315 18.5291C6.50654 17.9713 6.14977 16.9839 5.43622 15.0091L3.76819 10.3927Z",
    stroke: "#3DB72D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.25 14.0869H12.259",
    stroke: "#3DB72D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.25 22.0869H17.25",
    stroke: "#3DB72D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatluong);
export default __webpack_public_path__ + "static/media/chatluong.6c8240fb793606958c96c3d80169fd18.svg";
export { ForwardRef as ReactComponent };